// Copyright ©️ 2026 eVolve MEP, LLC

import * as THREE from 'three';

import type { HighlightableObjectName } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/HighlightableGroup';
import { labelTheming } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/labelTheming';
import {
  UnmarkedMeasurementLineGeometry,
  type UnmarkedMeasurementLineGeometryOpts,
} from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/UnmarkedMeasurementLineGeometry';

/** Simple subclass of UnmarkedMeasurementLineGeometry for leader lines.
 *  Leader lines connect the label or its connector line to the label measurements on the bend.
 **/
export class LeaderLineGeometry extends UnmarkedMeasurementLineGeometry {
  constructor(highlightableObjectName: HighlightableObjectName, layer?: UnmarkedMeasurementLineGeometryOpts['layer']) {
    super(highlightableObjectName, {
      start: new THREE.Vector3(),
      /** Offset X slightly to avoid degenerate geometry */
      end: new THREE.Vector3(0.001, 0, 0),
      lineType: 'dottedLine',
      layer,
      renderOrder: labelTheming.renderOrder.leaderLine,
    });
    // Hide the line initially, since it will be updated to the correct start and end points later.
    this.hide();
  }
}
